import React, { useContext } from "react";
import { FilterContext } from "../filters-context";
import useMediaQuery from "@mui/material/useMediaQuery";

const RegionFilter = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const onRegionClick = () => {
    if (filters.openedFilter === "region") {
      setOpenedFilter(null);
    } else {
      setOpenedFilter("region");
    }
  };
  const selectRegion = (region) => {
    setRegion(region);
  };

  const handleChange = (event) => {
    const region = innovantsFilters.region.find((region) => {
      return Number(event.target.value) === region.id;
    });
    setRegion(region);
  };
  const { filters, setRegion, setOpenedFilter, resetFilters } =
    useContext(FilterContext);
  return (
    <>
      {innovantsFilters &&
        innovantsFilters.region &&
        innovantsFilters.region.length > 0 && (
          <div
            className={`filter-container ${
              filters.openedFilter === "region" ? "is-open" : ""
            }`}
          >
            <button
              className={`filter-button ${
                filters.region && filters.region.label ? "is-selected" : ""
              }`}
              onClick={() => {
                onRegionClick();
              }}
            >
              {filters.region && filters.region.label
                ? filters.region.label
                : "Filtrer par région"}
            </button>
            {isMobile ? (
              <select
                name="region-select"
                id=""
                onChange={handleChange}
                value={filters.region?.id || ""}
              >
                <option value={""}>Toutes les régions</option>
                {innovantsFilters.region.map((region) => {
                  return (
                    <option key={region.id} value={region.id}>
                      {region.label}
                    </option>
                  );
                })}
              </select>
            ) : (
              <ul className="filter-list">
                {filters.region && filters.region.label && (
                  <li>
                    <button
                      onClick={() => {
                        selectRegion(null);
                      }}
                    >
                      Toutes les régions
                    </button>
                  </li>
                )}
                {innovantsFilters.region.map((region) => (
                  <li key={region.id}>
                    <button
                      onClick={() => {
                        selectRegion(region);
                      }}
                      id={region.id}
                    >
                      {region.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
    </>
  );
};

export default RegionFilter;
